import { animate, style, transition, trigger } from '@angular/animations';
import {
    Component,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ViewEncapsulation
} from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';

@Component({
    selector: 'lsq-data-table-mobile-card',
    template: `
        <div
            class="mtc"
            [ngClass]="{
                borderless: borderless,
                'not-clickable': !cardsAreClickable
            }"
        >
            <div class="mtc-header" (click)="handleCardClick()">
                <ng-container *ngTemplateOutlet="mobileCardHeader; context: { row: this.row }">
                </ng-container>

                <a class="mtc-header-chevron" *ngIf="cardsAreClickable">
                    <lsq-icon [color]="color.Gray" [type]="getChevronIconType()"> </lsq-icon>
                </a>
            </div>
            <div
                class="mtc-body"
                [@slideToggle]
                *ngIf="cardsAreExpandable && isOpen && !!mobileCardColumns"
            >
                <ng-container *ngTemplateOutlet="mobileCardColumns; context: { row: this.row }">
                </ng-container>

                <div
                    class="mtc-footer"
                    *ngIf="isOpen && !!mobileCardFooter"
                    (click)="handleFooterClick()"
                >
                    <ng-container *ngTemplateOutlet="mobileCardFooter; context: { row: this.row }">
                    </ng-container>
                </div>
            </div>
        </div>
    `,
    animations: [
        trigger('slideToggle', [
            transition(':enter', [
                style({
                    height: '0',
                    opacity: '0',
                    paddingTop: '0',
                    paddingBottom: '0'
                }),
                animate(
                    '400ms cubic-bezier(0, 0.9, 0.2, 1)',
                    style({
                        height: '*',
                        opacity: '1',
                        paddingTop: '*',
                        paddingBottom: '*'
                    })
                )
            ]),
            transition(':leave', [
                style({
                    height: '*',
                    opacity: '1'
                }),
                animate(
                    '400ms cubic-bezier(0, 0.9, 0.2, 1)',
                    style({
                        height: '0',
                        opacity: '0',
                        paddingTop: '0',
                        paddingBottom: '0'
                    })
                )
            ])
        ])
    ],
    styleUrls: ['./data-table-mobile-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqDataTableMobileCardComponent {
    @Input() public mobileCardHeader: TemplateRef<any>;
    @Input() public mobileCardColumns: TemplateRef<any>;
    @Input() public mobileCardFooter: TemplateRef<any>;
    @Input() public row: any;
    @Input() public isOpen = false;
    @Input() public borderless = false;
    @Input() public cardsAreExpandable = true;
    @Input() public cardsAreClickable = true;
    @Output() public rowExpanded = new EventEmitter<any>();
    @Output() public footerClick = new EventEmitter<any>();

    public color = Color;
    public icons = Icons;

    public getChevronIconType(): Icons {
        if (!this.cardsAreExpandable) {
            return Icons.ChevronRight;
        } else if (this.isOpen) {
            return Icons.ChevronUp;
        } else {
            return Icons.ChevronDown;
        }
    }

    public toggleIsOpen(): void {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
            this.rowExpanded.emit(this.row);
        }
    }

    public handleCardClick(): void {
        if (this.cardsAreExpandable) {
            this.toggleIsOpen();
        }
    }

    public handleFooterClick(): void {
        this.footerClick.emit();
    }
}
